import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en } from './translation/en';
import { de } from './translation/de';
import { normalizeLanguage } from './translation/language';
import store from 'store';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
	en: {
		translation: en
	},
	de: {
		translation: de
	}
};
//  Get language form redux store
const getLanguage = () => {
	const state = store.getState();
	return normalizeLanguage(state.siteConfig.language);
};

i18n.use(initReactI18next as any) // passes i18n down to react-i18next
	.init({
		resources,
		lng: getLanguage(),
		fallbackLng: 'de',
		keySeparator: false, // we do not use keys in form messages.welcome
		interpolation: {
			escapeValue: false
		}
	});

export default i18n;
const refreshLanguage = (language: string) => {
	const normalizedLanguage = normalizeLanguage(language);
	i18n.changeLanguage(normalizedLanguage);
	localStorage.setItem('lang', normalizedLanguage);
	// window.location.reload();
};
export { refreshLanguage, normalizeLanguage };
